import { Flex } from "../components/Flex";
import { Box } from "../components/Box";
import { Image } from "../components/Image";
import { H1 } from "../components/Heading";
import { Paragraph } from "../components/Paragraph";
import tillerVerifySvg from "../assets/verify-tiller.svg";
import googlePlayDownloadSvg from "../assets/google-play-download-icon.svg";
import appleStoreDownloadSvg from "../assets/apple-store-download-icon.svg";
import deeplinkReferenceSvg from "../assets/deeplink-reference-icon.svg";

const Fallback = () => {

    return (
        <Flex bg={"background"} height="100vh">
            <Flex
                width="900px"
                justifyContent="center"
                flexDirection="column"
                paddingLeft="60px"
                overflowY="auto"
            >
                <Image
                    src={tillerVerifySvg}
                    alt="tiller verify logo"
                    height="200px"
                    width="160px"
                />

                <Box>
                    <H1 color="darkBlue">You're almost there.</H1>
                    <Paragraph color="darkBlue">
                    Download the verify by Tiller app to continue.
                    </Paragraph>
                </Box>

                <Flex>
                <Image
                    src={googlePlayDownloadSvg}
                    alt="google play download"
                    height="200px"
                    width="160px"
                    paddingRight={"2"}
                    onClick={()=> window.open("https://play.google.com/store/apps/details?id=com.tiller.wealthxcel.verify", "_blank")}
                />
                <Image
                    src={appleStoreDownloadSvg}
                    alt="apple store download"
                    height="200px"
                    width="160px"
                    onClick={()=> window.open("https://apps.apple.com/gb/app/verify-by-tiller/id1645063264", "_blank")}
                />
                </Flex>

            </Flex>
            <Flex
                bg={"background"}
                display={{ _: "none", md: "flex" }}
                width="100%"
                justifyContent="center"
                alignItems="center"
            >
                <Image
                    src={deeplinkReferenceSvg}
                    alt="reference image"
                    display="block"
                    width="70%"
                    height="80%"
                />
            </Flex>
        </Flex>
    );
};

export default Fallback;
